export default function Navbar({ scrolled, onDonateClick }: { scrolled: boolean; onDonateClick?: () => void }) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <a
          href="#"
          className={`text-3xl font-black transition-colors ${
            scrolled ? 'text-gray-900' : 'text-white'
          }`}
          style={{ fontFamily: "'Noto Serif KR', serif" }}
        >
          신공<span className="text-amber-600">.</span>
        </a>

        <div className="flex items-center gap-12">
          <a
            href="#about"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            영화 소개
          </a>
          <a
            href="#synopsis"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            시놉시스
          </a>
          <a
            href="#casting"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            캐스팅
          </a>
          <a
            href="#rewards"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            리워드
          </a>
          <a
            href="#reviews"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            후기
          </a>
          <a
            href="#location"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled
                ? 'text-gray-700 hover:text-gray-900'
                : 'text-white/90 hover:text-white'
            }`}
          >
            오시는 길
          </a>
        </div>

        <button 
          onClick={onDonateClick}
          className="px-6 py-3 bg-amber-600 text-white font-bold rounded-full hover:bg-amber-700 transition-colors text-sm cursor-pointer whitespace-nowrap"
        >
          지금 후원하기
        </button>
      </div>
    </nav>
  );
}
